export default [
  {
    path: 'accounts/usergroup/:usergroupId/indexer/new',
    name: 'AddIndexer',
    component: () => import('@/app/indexer/views/AddIndexer.vue')
  },
  {
    path: 'accounts/usergroup/:usergroupId/indexer/:indexerId',
    name: 'IndexerDetail',
    component: () => import('@/app/indexer/views/IndexerDetail.vue')
  }
];